export default {
  segment: {
    justifyContent: 'flex-start'
  },
  label: {
    margin: '0 0 10px'
  }
}
